var map = {
	"./expired.png": "./src/assets/thai_qr_img/expired.png",
	"./thai_qr_img_1.png": "./src/assets/thai_qr_img/thai_qr_img_1.png",
	"./thai_qr_img_2.png": "./src/assets/thai_qr_img/thai_qr_img_2.png",
	"./thai_qr_img_3.png": "./src/assets/thai_qr_img/thai_qr_img_3.png",
	"./thai_qr_img_4.png": "./src/assets/thai_qr_img/thai_qr_img_4.png",
	"./thai_qr_img_5.png": "./src/assets/thai_qr_img/thai_qr_img_5.png",
	"./thai_qr_img_6.png": "./src/assets/thai_qr_img/thai_qr_img_6.png",
	"./thai_qr_img_7.png": "./src/assets/thai_qr_img/thai_qr_img_7.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/thai_qr_img sync recursive ^\\.\\/.*\\.png$";